import type { AppTab } from './TabsProvider';

export const MAX_TABS = 12;
export const STORAGE_KEY_PREFIX = 'prospera.app.tabs.v1';

export const getTabsStorageKey = (userId?: string | null) =>
  userId ? `${STORAGE_KEY_PREFIX}:${userId}` : null;

export const trimTabsByPolicy = (tabs: AppTab[], activeKey: string | null): AppTab[] => {
  if (tabs.length <= MAX_TABS) return tabs;

  const pinnedTabs = tabs.filter((tab) => tab.pinned);
  const regularTabs = tabs.filter((tab) => !tab.pinned);
  const regularLimit = MAX_TABS - pinnedTabs.length;

  if (regularLimit <= 0) return pinnedTabs;

  const retainedRegularTabs = [...regularTabs]
    // A aba ativa vem primeiro para nunca ser cortada; depois as usadas mais recentemente. Estava ao contrário: com o
    // limite cheio, a aba recém-aberta ia para o fim e era descartada, e a tela abria em branco (28/10/2026).
    .sort((a, b) => {
      if (a.key === activeKey) return -1;
      if (b.key === activeKey) return 1;
      return (b.lastActiveAt || 0) - (a.lastActiveAt || 0);
    })
    .slice(0, regularLimit);

  const retainedKeys = new Set([...pinnedTabs, ...retainedRegularTabs].map((tab) => tab.key));
  return tabs.filter((tab) => retainedKeys.has(tab.key));
};
